import { DomainTargeting, type DomainTargetingType } from '@openx/types/targeting/domains.ts';
import type { TFunction } from 'i18next';

export const getDomainTargetingLabel = (type: DomainTargetingType, t: TFunction<'translation'>) => {
  switch (type) {
    case DomainTargeting.ALL_VARIATIONS:
      return t('All subdomains with paths');
    case DomainTargeting.NO_SUBDOMAINS:
      return t('Root domains with paths');
    default:
      return t('All subdomains with paths');
  }
};
